import * as Yup from "yup";
import { ssn_validator, Strong_Password } from "./ValidationFunctions";

export const validationSchema = Yup.object({
  cellphone: Yup.string()
    .required("شماره موبایل خود را وارد کنید")
    .matches(
      "^[0][9][0-9]{9}$" || "^[۰][۹][۰-۹]{9}$",
      "شماره اشتباه است (09xxxx)"
    ),
  email: Yup.string().required("ایمیل خود را وارد کنید"),
  first_name: Yup.string().required("نام خود را وارد کنید"),
  last_name: Yup.string().required("نام خوانوادگی خود را وارد کنید"),
  ssn: Yup.lazy((value) => {
    if (value !== undefined && ssn_validator(value) === false) {
      return Yup.string().matches("aa", "کد ملی اشتباه است");
    }
    return Yup.string().required("کد ملی را وارد کنید");
  }),
  old_password: Yup.string()
    .required("پسورد قبلی را وارد کنید")
    .matches(
      Strong_Password,
      "پسورد حداقل 8 کاراکتر و شامل حروف کوچک،بزرگ،اعداد  و (@،!،%،..)است"
    ),
  password: Yup.string()
    .required("پسورد را وارد کنید")
    .matches(
      Strong_Password,
      "پسورد حداقل 8 کاراکتر و شامل حروف کوچک،بزرگ،اعداد  و (@،!،%،..)است"
    ),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("password"), null], "پسورد اشتباه است")
    .required("پسورد را مجددا وارد کنید"),
  role: Yup.string(),
  default_page_link: Yup.string(),
});

export const initialValue = {
  cellphone: "",
  email: "",
  first_name: "",
  last_name: "",
  ssn: "",
  password: "",
  old_password: "",
  confirm_password: "",
  role: "",
  default_page_link: "",
};
